import { gql } from '__generated__';

export default gql(`
  query GetLotteriesForEvent($project_id: ID!, $event_id: ID!) {
    project(id: $project_id) {
      id
      event(id: $event_id) {
        id
        title
        logo {
          id
          url
        }
        brand_color
        locale
        tickets {
          id
          title
          allow_lottery_confirmations
          promotions {
            id
            title
            amount
          }
          time_slots {
            id
            start_date
            start_time
            title
            multi_date
          }
        }
        lotteries {
          id
          title
          start_date
          end_date
          started
          ended
          confirmable
          deletable
          registrations_count
          pending_registrations_count
          confirmed_registrations_count
          ticket {
            id
            title
          }
          promotion {
            id
            title
          }
          time_slot {
            id
            start_date
            start_time
            multi_date
            title
          }
        }
      }
    }
  }
`);
